import React from 'react'
import "./Subscription_Plan.css"

function Subscription_Plan() {
    return (
        <>
            <section className='profile_Subscription_Plan Personal_Details'>
                <div className="Plan_text_holder">
                    <h6>Plan Activated: 02 Jan 2025 To 10 Feb 2025</h6>
                </div>

                <div className='subscription_plan_holder'>
                    <section className='Subscription_Plan_card active'>
                        <div className="heading_text">
                            <div className='price_holder'>
                                <div className='list_heading_text'>
                                    <p>PLAN NAME</p>
                                </div>
                                <div className="list_content_holder">
                                    <h3>₹. 4560</h3>
                                </div>
                            </div>
                        </div>
                        <div className="info_holder">
                            <div className='duration_holder flex_box'>
                                <div className='list_heading_text'>
                                    <h3 >Duration:</h3>
                                </div>
                                <div className="list_content_holder">
                                    <p>
                                        10–15 days  <br /> <sub>(1 hour daily)</sub>
                                    </p>
                                </div>
                            </div>
                            <div className='duration_holder flex_box'>
                                <div className='list_heading_text'>
                                    <h3>Features:</h3>
                                </div>
                                <div className="list_content_holder">
                                    <ul>
                                        <li> Access to selected videos</li>
                                        <li> Standard support </li>
                                        <li> Limited downloads</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div className="Reminder_holder">
                    <p className='bold_text'>Reminder: </p>
                    <p>Your plan ends in 5 days. Click below to renew and avoid service disruption.</p>
                </div>


            </section>
        </>
    )
}

export default Subscription_Plan